"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferAction = void 0;
const sdk_1 = require("@malloc-protocol/sdk");
const token_instructions_1 = require("@project-serum/serum/lib/token-instructions");
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const cpi_action_1 = require("../utils/cpi-action");
const { actionMetasToAccountsArray } = sdk_1.utils.object;
const cpi_action_json_1 = __importDefault(require("../../target/idl/cpi_action.json"));
const actionTypeUID = "MALLOC_SPL_TRANSFER";
const buildIsolatedTransfer = ({ inp, inputTokens: tokAccountIns, actionPID, provider, authority, }) => __awaiter(void 0, void 0, void 0, function* () {
    const recipient = new web3_js_1.PublicKey(inp.recipientWallet);
    const mintIn = new web3_js_1.PublicKey(tokAccountIns[0].mint);
    const { associateTokAccount, instr: createTokInstr } = yield sdk_1.utils.tokens.tryCreateAssociatedAccountInst(mintIn, recipient, provider.connection, provider.wallet.publicKey);
    const inst = (0, token_instructions_1.transfer)({
        source: tokAccountIns[0].tokenAccount,
        destination: associateTokAccount,
        amount: 0,
        owner: authority,
    });
    return {
        estimateOuts: () => [],
        isolatedAction: {
            actionTypeUID,
            tokenMintIn: mintIn,
            actionData: (0, cpi_action_1.packInstrData)(inst.data, cpi_action_1.InstructionType.TRANSFER),
            actionProgram: new web3_js_1.PublicKey(actionPID),
            actionAccounts: [
                { address: spl_token_1.TOKEN_PROGRAM_ID },
                ...actionMetasToAccountsArray(inst.keys),
            ],
            additionalSigners: [],
            tokenMintOuts: [],
            tokenAccountOuts: [],
            // TODO: the following is a bit ghetto, but basically will ensure that the token account is only created if the recipient
            // is not the caller. This ensures that the token account is not created again because its probably created by a former action/ token analyzer
            opts: {
                instructions: createTokInstr && !recipient.equals(provider.wallet.publicKey) // TODO: think of a better way to do this with tokens
                    ? [createTokInstr]
                    : undefined,
            },
        },
    };
});
exports.TransferAction = {
    buildIsolatedAction: buildIsolatedTransfer,
    expectedNumberOutMints: 0,
    actionTypeUID,
    idl: cpi_action_json_1.default,
};
